App.factory('Payment', ['restmod', restmod => {
  return restmod.model('/payments').mix({
    status_update: { hasMany: 'PaymentStatusUpdate' }
  })
}])
